/* eslint-disable */

const GET_ADVENTUROUS_JOURNEY_TEMPLATES =
  'dofe-bo/advjouTemplates/GET_ADVENTUROUS_JOURNEY_TEMPLATES'
const GET_ADVENTUROUS_JOURNEY_TEMPLATES_SUCCESS =
  'dofe-bo/advjouTemplates/GET_ADVENTUROUS_JOURNEY_TEMPLATES_SUCCESS'
const GET_ADVENTUROUS_JOURNEY_TEMPLATES_FAIL =
  'dofe-bo/advjouTemplates/GET_ADVENTUROUS_JOURNEY_TEMPLATES_FAIL'

const GET_ADVENTUROUS_JOURNEY_TEMPLATE =
  'dofe-bo/advjouTemplates/GET_ADVENTUROUS_JOURNEY_TEMPLATE'
const GET_ADVENTUROUS_JOURNEY_TEMPLATE_SUCCESS =
  'dofe-bo/advjouTemplates/GET_ADVENTUROUS_JOURNEY_TEMPLATE_SUCCESS'
const GET_ADVENTUROUS_JOURNEY_TEMPLATE_FAIL =
  'dofe-bo/advjouTemplates/GET_ADVENTUROUS_JOURNEY_TEMPLATE_FAIL'

const CREATE_ADVENTUROUS_JOURNEY_TEMPLATES =
  'dofe-bo/advjouTemplates/CREATE_ADVENTUROUS_JOURNEY_TEMPLATES'
const CREATE_ADVENTUROUS_JOURNEY_TEMPLATES_SUCCESS =
  'dofe-bo/advjouTemplates/CREATE_ADVENTUROUS_JOURNEY_TEMPLATES_SUCCESS'
const CREATE_ADVENTUROUS_JOURNEY_TEMPLATES_FAIL =
  'dofe-bo/advjouTemplates/CREATE_ADVENTUROUS_JOURNEY_TEMPLATES_FAIL'

const UPDATE_ADVENTUROUS_JOURNEY_TEMPLATES =
  'dofe-bo/advjouTemplates/UPDATE_ADVENTUROUS_JOURNEY_TEMPLATES'
const UPDATE_ADVENTUROUS_JOURNEY_TEMPLATES_SUCCESS =
  'dofe-bo/advjouTemplates/UPDATE_ADVENTUROUS_JOURNEY_TEMPLATES_SUCCESS'
const UPDATE_ADVENTUROUS_JOURNEY_TEMPLATES_FAIL =
  'dofe-bo/advjouTemplates/UPDATE_ADVENTUROUS_JOURNEY_TEMPLATES_FAIL'

const DELETE_ADVENTUROUS_JOURNEY_TEMPLATES =
  'dofe-bo/advjouTemplates/DELETE_ADVENTUROUS_JOURNEY_TEMPLATES'
const DELETE_ADVENTUROUS_JOURNEY_TEMPLATES_SUCCESS =
  'dofe-bo/advjouTemplates/DELETE_ADVENTUROUS_JOURNEY_TEMPLATES_SUCCESS'
const DELETE_ADVENTUROUS_JOURNEY_TEMPLATES_FAIL =
  'dofe-bo/advjouTemplates/DELETE_ADVENTUROUS_JOURNEY_TEMPLATES_FAIL'

const SET_FILTER = 'dofe-bo/advjouTemplates/SET_FILTER'
const SET_PARAMS = 'dofe-bo/advjouTemplates/SET_PARAMS'
const SET_DISABLED_CACHE = 'dofe-bo/advjouTemplates/SET_DISABLED_CACHE'
const REMOVE_DETAIL_DATA = 'dofe-bo/advjouTemplates/REMOVE_DETAIL_DATA'

const initialState = {
  list: [],
  detail: {},
  sort: '',
  offset: 0,
  limit: 20,
  pages: 4,
  count: null,
  filter: '',
  loading: false,
  loaded: false
}

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_ADVENTUROUS_JOURNEY_TEMPLATES:
      return {
        ...state,
        loading: true
      }
    case GET_ADVENTUROUS_JOURNEY_TEMPLATES_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        list: action.result,
        count: action.headers['x-total-count'],
        pages:
          Math.ceil(Number(action.headers['x-total-count']) / state.limit) ||
          state.pages
      }
    case GET_ADVENTUROUS_JOURNEY_TEMPLATES_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }
    case GET_ADVENTUROUS_JOURNEY_TEMPLATE:
      return {
        ...state,
        loading: true
      }
    case GET_ADVENTUROUS_JOURNEY_TEMPLATE_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        detail: action.result
      }
    case GET_ADVENTUROUS_JOURNEY_TEMPLATE_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }
    case CREATE_ADVENTUROUS_JOURNEY_TEMPLATES:
      return {
        ...state,
        loading: true
      }
    case CREATE_ADVENTUROUS_JOURNEY_TEMPLATES_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        detail: action.result
      }
    case CREATE_ADVENTUROUS_JOURNEY_TEMPLATES_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }
    case UPDATE_ADVENTUROUS_JOURNEY_TEMPLATES:
      return {
        ...state,
        loading: true
      }
    case UPDATE_ADVENTUROUS_JOURNEY_TEMPLATES_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        detail: action.result
      }
    case UPDATE_ADVENTUROUS_JOURNEY_TEMPLATES_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }
    case SET_FILTER:
      return Object.assign({}, state, {
        filter: action.filterBy
      })
    case SET_PARAMS:
      return {
        ...state,
        limit:
          action.options.limit !== undefined
            ? action.options.limit
            : state.limit,
        offset:
          action.options.offset !== undefined
            ? action.options.offset
            : state.offset,
        filter:
          action.options.filter !== undefined
            ? action.options.filter
            : state.filter,
        sort:
          action.options.sort !== undefined ? action.options.sort : state.sort
      }
    case SET_DISABLED_CACHE:
      return Object.assign({}, state, {
        loaded: false
      })
    case REMOVE_DETAIL_DATA:
      return Object.assign({}, state, {
        detail: {}
      })
    default:
      return state
  }
}

export function getAjTemplates({ filter = null, limit, offset, sort }) {
  const query = filter ? `&filter=${filter}` : ''
  const firstRow = (offset && `&firstRow=${offset}`) || ''
  const maxRows = (limit && `&maxRows=${limit}`) || ''
  const getTotalRowCount = '&getTotalRowCount=true'
  const sortQuery = (sort && `&sort=${sort}`) || ''

  return {
    types: [
      GET_ADVENTUROUS_JOURNEY_TEMPLATES,
      GET_ADVENTUROUS_JOURNEY_TEMPLATES_SUCCESS,
      GET_ADVENTUROUS_JOURNEY_TEMPLATES_FAIL
    ],
    promise: client =>
      client.get(
        `api/aj-event-templates?with=ACTIVITY_CATEGORY,AWARD_LEVEL,ORGANIZATION,COUNTRY${query}${maxRows}${firstRow}${getTotalRowCount}${sortQuery}`
      )
  }
}

export function getAjTemplate(id) {
  return {
    types: [
      GET_ADVENTUROUS_JOURNEY_TEMPLATE,
      GET_ADVENTUROUS_JOURNEY_TEMPLATE_SUCCESS,
      GET_ADVENTUROUS_JOURNEY_TEMPLATE_FAIL
    ],
    promise: client =>
      client.get(
        `api/aj-event-templates/${id}?with=ACTIVITY_CATEGORY,AWARD_LEVEL,ORGANIZATION,COUNTRY`
      )
  }
}

export function createAjTemplate(data) {
  return {
    types: [
      CREATE_ADVENTUROUS_JOURNEY_TEMPLATES,
      CREATE_ADVENTUROUS_JOURNEY_TEMPLATES_SUCCESS,
      CREATE_ADVENTUROUS_JOURNEY_TEMPLATES_FAIL
    ],
    promise: client =>
      client.post('api/aj-event-templates/creation', {
        data
      })
  }
}

export function updateAjTemplate(id, data) {
  return {
    types: [
      UPDATE_ADVENTUROUS_JOURNEY_TEMPLATES,
      UPDATE_ADVENTUROUS_JOURNEY_TEMPLATES_SUCCESS,
      UPDATE_ADVENTUROUS_JOURNEY_TEMPLATES_FAIL
    ],
    promise: client =>
      client.post(`api/aj-event-templates/${id}/edit`, {
        data
      })
  }
}

export function deleteAjTemplate(id) {
  return {
    types: [
      DELETE_ADVENTUROUS_JOURNEY_TEMPLATES,
      DELETE_ADVENTUROUS_JOURNEY_TEMPLATES_SUCCESS,
      DELETE_ADVENTUROUS_JOURNEY_TEMPLATES_FAIL
    ],
    promise: client => client.del(`api/aj-event-templates/${id}`)
  }
}

export function setFilter(filterBy) {
  return {
    type: SET_FILTER,
    filterBy
  }
}

export function setAjTemplatesParams(options) {
  return {
    type: SET_PARAMS,
    options
  }
}

export function removeDetailData() {
  return {
    type: REMOVE_DETAIL_DATA
  }
}

export function removeCache() {
  return {
    type: SET_DISABLED_CACHE
  }
}

/* eslint-enable */
